import React from 'react';
import { StyledWidgetWrapper } from '../../Dashboard.styles';
import HRVacanciesWidgetComponent from '../Widget/HRVacanciesWidget.component';

export const WidgetWrapperComponent = () => {
  return (
    <StyledWidgetWrapper>
      <HRVacanciesWidgetComponent />
    </StyledWidgetWrapper>
  );
};
